/* Shipmentoo Kartenverhalten — ausgelagert am 06.09.2026.
   Vorher stand dieses Skript einmal je Karte im HTML; ausgefuehrt wurde
   ohnehin nur die erste Kopie (window.smk2CardInit). Ob eine Kategorie-
   seite vorliegt, steht jetzt in window.SMK_KATEGORIE (im Layout gesetzt). */
/* SHIPMENTOO ENTWURF 2026 - Kartenverhalten.
     Steht bewusst im Rumpf: Skripte im Seitenkopf werden in diesem Theme
     ausgeliefert, aber von den eingebundenen Apps nie ausgefuehrt. */
  if (!window.smk2CardInit) {
    window.smk2CardInit = true;

    var svgCart = '<svg viewBox="0 0 22 22" fill="none"><path d="M7 8V6.5a4 4 0 018 0V8" stroke="white" stroke-width="1.7" stroke-linecap="round"/><rect x="3" y="8" width="16" height="12" rx="2.5" stroke="white" stroke-width="1.7"/><line x1="11" y1="12.5" x2="11" y2="16.5" stroke="white" stroke-width="1.7" stroke-linecap="round"/><line x1="9" y1="14.5" x2="13" y2="14.5" stroke="white" stroke-width="1.7" stroke-linecap="round"/></svg>';
    var svgCheck = '<svg viewBox="0 0 22 22" fill="none"><polyline points="4,11 9,16 18,6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    /* ---- Klick auf die Karte fuehrt zur Artikelseite ---- */
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.js-smk2-card');
      if (!card) return;
      if (e.target.closest('button, a, form, product-form')) return;
      window.location.href = card.dataset.url;
    });

    /* ---- In den Warenkorb ----
       Die Beschriftung liegt in einem eigenen <span>. Nur so kann das
       Stylesheet sie beim Zustandswechsel ausblenden und weichzeichnen;
       ein blosser Textknoten laesst sich nicht ansprechen. */
    function smk2Huelle(btn) {
      var h = btn.querySelector('.smk2-atc-text');
      if (!h) {
        h = document.createElement('span');
        h.className = 'smk2-atc-text';
        while (btn.firstChild) h.appendChild(btn.firstChild);
        btn.appendChild(h);
      }
      return h;
    }

    /* Wechselt die Beschriftung, ohne dass alter und neuer Text sichtbar
       uebereinanderliegen: erst ausblenden, dann tauschen, dann einblenden. */
    function smk2Beschriften(btn, inhalt, istHtml) {
      var h = smk2Huelle(btn);
      h.style.opacity = '0';
      h.style.filter = 'blur(3px)';
      setTimeout(function () {
        if (istHtml) { h.innerHTML = inhalt; } else { h.textContent = inhalt; }
        h.style.opacity = '';
        h.style.filter = '';
      }, 110);
    }

    window.smk2CartAdd = function (btn) {
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      var label = btn.getAttribute('data-label');
      smk2Huelle(btn);
      btn.classList.add('smk2-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.remove('smk2-loading');
        btn.classList.add('smk2-done');
        if (label) {
          smk2Beschriften(btn, svgCheck + '<span>Im Warenkorb</span>', true);
        } else {
          smk2Beschriften(btn, svgCheck, true);
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.textContent = cart.item_count > 0 ? cart.item_count : '';
          var cd = document.getElementById('cart-drawer');
          if (cd) {
            if (typeof cd.refresh === 'function') cd.refresh();
            if (typeof cd.open === 'function') cd.open();
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });
        setTimeout(function () {
          btn.classList.remove('smk2-done');
          if (label) { smk2Beschriften(btn, label, false); }
          else { smk2Beschriften(btn, svgCart, true); }
        }, 3000);
      })
      .catch(function () { btn.classList.remove('smk2-loading'); window.location.href = '/cart'; });
    };

    /* ---- Stueckpreis ----
       Gerechnet wird aus dem ANGEZEIGTEN Paketpreis, nicht aus variant.price:
       variant.price ist netto, und ob daneben netto oder brutto steht,
       entscheidet die Bruecke zum T-Selector (sie schreibt [data-smk-price]
       aus data-price-cents neu). Wer selbst aus variant.price teilt, stellt
       zwei Steuerbasen nebeneinander.

       Der Stueckpreis traegt darum ein eigenes Attribut: [data-smk-unit]
       wuerde die Bruecke selbst ueberschreiben - mit zwei Nachkommastellen
       und der festen Annahme, ein Paket habe 100 Stueck. Hier wird mit der
       echten Verpackungseinheit gerechnet. */
    function smk2Zahl(txt) {
      var m = String(txt).replace(/\s/g, '').match(/-?[\d.]*\d(?:,\d+)?/);
      if (!m) return NaN;
      return parseFloat(m[0].replace(/\./g, '').replace(',', '.'));
    }
    function smk2Symbol(txt) {
      var rest = String(txt).replace(/[\d.,\s]/g, '');
      return rest || '€';
    }
    function smk2Stueck() {
      var felder = [].slice.call(document.querySelectorAll('[data-smk-stueck]'));
      felder.forEach(function (el) {
        var box = el.closest('.smk2-gfoot, .smk2-foot');
        var p = box ? box.querySelector('[data-smk-price]') : null;
        if (!p) return;
        var pieces = parseInt(el.getAttribute('data-pieces'), 10);
        var betrag = smk2Zahl(p.textContent);
        if (!pieces || pieces < 2 || !isFinite(betrag)) return;
        var wert = betrag / pieces;
        /* Unter einem Euro drei Nachkommastellen, sonst sehen 4,5 und 5,4 Cent
           beide wie 0,05 Euro aus. Darueber reichen zwei. */
        var stellen = wert < 1 ? 3 : 2;
        var neu = wert.toLocaleString('de-DE', { minimumFractionDigits: stellen, maximumFractionDigits: stellen })
                + ' ' + smk2Symbol(p.textContent);
        if (el.textContent.trim() !== neu) el.textContent = neu;
      });
    }

    /* ---- Massstab fuer die Silhouetten ----
       Alle Kacheln einer Warenreihe teilen eine Skala und eine Grundlinie.
       Der gestrichelte Umriss ist der groesste Beutel der Reihe.

       Gerechnet wird mit der Gesamthoehe aus Beutel UND Klappe, sonst ragt
       die Klappe oben aus der Buehne. */
    function smk2Skala() {
      var alle = [].slice.call(document.querySelectorAll('.smk2-buehne'));
      if (!alle.length) return;
      /* Je Warenreihe ein eigener Massstab. Auf einer Kategorieseite gibt es
         nur eine Gruppe - dort aendert sich also nichts. Auf der Startseite
         stehen sieben Reihen untereinander; wuerde eine gemeinsame Skala ueber
         alle gelten, waere der kleinste Beutel neben der groessten Papiertasche
         ein Fliegendreck. */
      var kaesten = [], gruppen = [];
      alle.forEach(function (e) {
        var kasten = e.closest ? e.closest('.smkr-innen') : null;
        var i = kaesten.indexOf(kasten);
        if (i === -1) { kaesten.push(kasten); gruppen.push([e]); }
        else { gruppen[i].push(e); }
        smk2Beobachten(e);
      });
      gruppen.forEach(smk2SkalaGruppe);
    }

    /* Nachgeladene Abschnitte - die Produktempfehlungen etwa - bekommen ihre
       endgueltige Breite erst, wenn das Karussell fertig aufgebaut ist. Ohne
       diese Beobachtung bliebe die Skala auf dem Wert von vorher stehen und
       die Silhouetten waeren winzig. */
    function smk2Beobachten(buehne) {
      if (!window.ResizeObserver || buehne.__smk2RO) return;
      buehne.__smk2RO = true;
      if (!window.__smk2Beobachter) {
        window.__smk2Beobachter = new ResizeObserver(function () { smk2Spaeter(); });
      }
      window.__smk2Beobachter.observe(buehne);
    }

    function smk2SkalaGruppe(buehnen) {
      if (!buehnen.length) return;
      var maxB = 0, maxH = 0, maxGes = 0;
      buehnen.forEach(function (e) {
        var b = parseInt(e.getAttribute('data-mm-b'), 10) || 0;
        var h = parseInt(e.getAttribute('data-mm-h'), 10) || 0;
        var l = parseInt(e.getAttribute('data-mm-lasche'), 10) || 0;
        maxB = Math.max(maxB, b);
        maxH = Math.max(maxH, h);
        maxGes = Math.max(maxGes, h + l);
      });
      /* Masse von der ersten SICHTBAREN Buehne: Karten ausserhalb des
         Sichtfelds koennen 0 melden. */
      var sicht = buehnen.filter(function (e) { return e.clientWidth > 0; });
      if (!sicht.length) return;
      var hoehe = sicht[0].clientHeight, breite = sicht[0].clientWidth;
      if (!maxB || !maxH || !hoehe || !breite) return;
      if (!maxGes) maxGes = maxH;
      var foto = sicht[0].querySelector('.smk2-foto');
      var fotoB = foto ? foto.offsetWidth : 0;
      /* Die Abbildung steht IMMER neben dem Foto, nie darunter. */
      var s = Math.min((breite - fotoB - 12) / maxB, (hoehe - 6) / maxGes);
      if (!(s > 0)) return;
      buehnen.forEach(function (e) {
        var mb = parseInt(e.getAttribute('data-mm-b'), 10) || 0;
        var mh = parseInt(e.getAttribute('data-mm-h'), 10) || 0;
        var ml = parseInt(e.getAttribute('data-mm-lasche'), 10) || 0;
        var beutel = e.querySelector('.smk2-beutel');
        if (beutel) {
          beutel.style.width = (mb * s).toFixed(1) + 'px';
          beutel.style.height = (mh * s).toFixed(1) + 'px';
        }
        var klappe = e.querySelector('.smk2-klappe');
        if (klappe) {
          if (ml > 0) {
            klappe.style.display = 'block';
            klappe.style.height = Math.max(ml * s, 2).toFixed(1) + 'px';
          } else {
            klappe.style.display = 'none';
          }
        }
        var ref = e.querySelector('.smk2-ref');
        if (ref) {
          if (mb >= maxB && (mh + ml) >= maxGes) {
            ref.style.display = 'none';
          } else {
            ref.style.display = 'block';
            ref.style.width = (maxB * s).toFixed(1) + 'px';
            ref.style.height = (maxGes * s).toFixed(1) + 'px';
          }
        }
        var din = e.querySelector('.smk2-din');
        if (din) {
          var db = parseInt(e.getAttribute('data-din-b'), 10) || 0;
          var dh = parseInt(e.getAttribute('data-din-h'), 10) || 0;
          if (db && dh) {
            din.style.display = 'flex';
            din.style.width = (db * s).toFixed(1) + 'px';
            din.style.height = (dh * s).toFixed(1) + 'px';
            var soll = (dh * s) >= 26 ? (din.getAttribute('data-label') || '') : '';
            if (din.textContent !== soll) din.textContent = soll;
          } else {
            din.style.display = 'none';
          }
        }
      });
    }

    /* ---- Leiste "Was soll hinein?" ----
       Wird nur gebaut, wenn auf der Seite genug Kacheln mit DIN-Format stehen. */
    var DIN_NAMEN = { 1: 'A6', 2: 'A5', 3: 'A4', 4: 'A3', 5: 'A2', 6: 'A1' };
    function smk2Filter() {
      /* Nur auf Kategorieseiten. Auf der Startseite stehen mehrere Warenreihen
         untereinander - eine Leiste ueber der ersten wuerde die anderen
         stumm mitfiltern. */
      if (!window.SMK_KATEGORIE) return;
      if (document.querySelector('.smk2-filter')) return;
      var karten = [].slice.call(document.querySelectorAll('.smk2-card[data-din-rang]'));
      var mit = karten.filter(function (k) { return (parseInt(k.getAttribute('data-din-rang'), 10) || 0) > 0; });
      if (mit.length < 3) return;

      var knoten = mit[0].parentElement, raster = null;
      while (knoten && knoten !== document.body) {
        if (knoten.querySelectorAll('.smk2-card').length >= 2) { raster = knoten; break; }
        knoten = knoten.parentElement;
      }
      if (!raster || !raster.parentElement) return;

      var raenge = [];
      mit.forEach(function (k) {
        var r = parseInt(k.getAttribute('data-din-rang'), 10);
        if (raenge.indexOf(r) === -1) raenge.push(r);
      });
      raenge.sort(function (a, b) { return a - b; });
      if (raenge.length < 2) return;

      var leiste = document.createElement('div');
      leiste.className = 'smk2-filter';
      var frage = document.createElement('span');
      frage.className = 'smk2-filter-frage';
      frage.textContent = 'Was soll hinein?';
      leiste.appendChild(frage);

      function zuruecksetzen() {
        [].slice.call(leiste.querySelectorAll('.smk2-fchip')).forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        karten.forEach(function (k) { k.classList.remove('smk2-aus', 'smk2-treffer'); });
      }

      raenge.forEach(function (rang) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'smk2-fchip';
        chip.textContent = DIN_NAMEN[rang] || '';
        chip.setAttribute('aria-pressed', 'false');
        chip.addEventListener('click', function () {
          var an = chip.getAttribute('aria-pressed') === 'true';
          zuruecksetzen();
          if (an) return;
          chip.setAttribute('aria-pressed', 'true');
          var passend = [];
          karten.forEach(function (k) {
            var r = parseInt(k.getAttribute('data-din-rang'), 10) || 0;
            if (r >= rang) { passend.push(k); } else { k.classList.add('smk2-aus'); }
          });
          passend.sort(function (a, b) {
            return (parseInt(a.getAttribute('data-flaeche'), 10) || 0)
                 - (parseInt(b.getAttribute('data-flaeche'), 10) || 0);
          });
          /* Markiert wird die kleinste Groesse, die man auch bestellen kann. */
          var kaufbar = passend.filter(function (k) { return !k.querySelector('.smk2-atc-leer'); });
          var ziel = kaufbar[0] || passend[0];
          if (ziel) ziel.classList.add('smk2-treffer');
        });
        leiste.appendChild(chip);
      });

      var alle = document.createElement('button');
      alle.type = 'button';
      alle.className = 'smk2-falle';
      alle.textContent = 'Alle zeigen';
      alle.addEventListener('click', zuruecksetzen);
      leiste.appendChild(alle);

      raster.parentElement.insertBefore(leiste, raster);
    }

    /* ---- Anstoss und Nachziehen ---- */
    function smk2Auffrischen() { smk2Skala(); smk2Stueck(); smk2Filter(); }
    window.smk2Auffrischen = smk2Auffrischen;
    var wartet = null;
    function smk2Spaeter() {
      if (wartet) clearTimeout(wartet);
      wartet = setTimeout(smk2Auffrischen, 120);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', smk2Auffrischen);
    } else {
      smk2Auffrischen();
    }
    window.addEventListener('load', smk2Auffrischen);
    window.addEventListener('resize', smk2Spaeter);
    if (window.MutationObserver) {
      new MutationObserver(smk2Spaeter).observe(document.body, { childList: true, subtree: true });
    }
  }